import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { TableCell } from '@material-ui/core';
import TruncatedList from '../../components/TruncatedList';
import { SCOPE_INLINE_LIMIT } from './user.helper';

export const UserTableCell = withStyles(() => ({
    root: {
        fontSize: 13,
        color: '#1f2937',
        borderBottom: '1px solid #eef0f3',
        padding: '10px 12px',
    },
}))(TableCell);

export const UserTableHeadCell = withStyles(() => ({
    root: {
        fontSize: 12,
        fontWeight: 700,
        color: '#6b7280',
        background: '#fafbfc',
        borderBottom: '1px solid #e3e6ea',
        padding: '10px 12px',
        position: 'sticky',
        top: 0,
        zIndex: 1,
    },
}))(TableCell);

/** Shows the first few scope values and collapses the rest — a Regional Approver's expanded store
 * list can run to hundreds, so it is never rendered in full in a table cell. */
export const ScopeCell: React.FC<{ values?: string[]; scopeType?: string }> = ({
    values,
    scopeType,
}) => {
    if (scopeType === 'GLOBAL') return <span>All (global)</span>;
    if (!values || values.length === 0) return <span>-</span>;

    // Same component Vendor Management uses for Hubs Active, so the pills match across tabs and
    // the overflow behaviour is defined in one place rather than hand-rolled per table.
    //
    // A vendor login holds no scope rows: its single value is the organisation it is bounded by.
    // Rendered as a pill like the rest so the column reads consistently.
    const heading =
        scopeType === 'ORG'
            ? 'Vendor organisation'
            : scopeType === 'ZONE'
              ? 'Zones'
              : 'Stores';

    return (
        <TruncatedList
            items={values}
            limit={scopeType === 'ORG' ? 1 : SCOPE_INLINE_LIMIT}
            title={heading}
        />
    );
};
